import Txt from "@/components/ui/utils/Txt";
import Badge from "@/components/ui/utils/Badge";
import Icon from "@/components/ui/utils/Icon";
import JsonBrowser from "@/components/ui/lists/JsonBrowser";

export default {
    props : {
        items: {type: Array },
        fields: {type: Array },
        preformatted:{type:Boolean, default: false},
        itemType: {type: String, default: "item" },
    },

    computed : {
        allActions() {
            let actions = {}
            for (let f of this.fields) if (f.actions) {
                for (let a of f.actions) if (a.action) actions[a.action] = true
            }
            return Object.keys(actions);
        },
    },

    methods : {
        actionBinding(item, index) {
            const res = {}
            for (let a of this.allActions) {
                res[a] = () => {
                    this.doAction(a, item, index)
                }
            }
            return res
        },
        itemTag(field, item) {
            const type = typeof field.type === "function" ? field.type() : field.type
            if (type === 'image') return this.val(field, item, field.format) ? 'img' : 'span'
            if (type === 'icon') return Icon
            if (type === 'json') return JsonBrowser
            else if (type === 'boolean') return Badge
            else if (type === 'badge') return Badge
            return Txt
        },

        itemIcon(field, item) {
            if (field.type === 'icon') return this.val(field, item, field.format)
        },

        itemSrc(field, item) {
            const type = typeof field.type === "function" ? field.type() : field.type
            if (type === 'image') {
                return this.val(field, item, field.format)
            }
        },

        itemClass(field, item) {
            let cls = '';

            const type = typeof field.type === "function"?field.type():field.type
            const res = this.getVal(field, item)

            if (!type) {
                if (field.mood) cls += (typeof field.mood === 'function' ? field.mood(res, item) : field.mood)
            }

            if (type === 'boolean') {
                if (field.mood) cls = 'badge '+ (typeof field.mood === 'function' ? field.mood(res, item) : field.mood)
                else if (res) { if (!field.negative || field.always) cls = 'badge success' }
                else { if (field.negative || field.always) cls = 'badge danger' }
            }
            if (type === 'badge') {
                let f = 'badge';
                if (field.mood) f += ' '+(typeof field.mood === 'function' ? field.mood(res, item) : field.mood)
                cls = f
            }
            if (type === 'color') cls = 'badge'
            if (type === 'image' && this.val(field, item)) cls = 'preview-image'
            if (field.bold) {
                if (typeof field.bold === "function") cls += field.bold(this.getVal(field, item), item)?'bold':''
                else cls += 'bold'
            }
            if (field.primary) cls += 'bold'

            return cls
        },

        itemStyle(field, item) {
            const type = typeof field.type === "function"?field.type():field.type

            if (type === 'color') {
                return {background: this.val(field, item)}
            }
            else if (type === 'boolean') {
                return {display: field.always || (this.val(field, item) || field.negative)?'':'none'}
            }
        },

        itemContent(field, item) {

            const type = typeof field.type === "function"?field.type():field.type
            const val = this.val(field, item, field.format);
            if (type === 'image' || type === 'color') return ''
            if (type === 'boolean') {
                if (field.labelTrue && val) return field.labelTrue
                if (field.labelFalse && !val) return field.labelFalse
                return ''
            }
            return val;
        },

        itemValue(field, item) {
            if (field.type === 'json') return this.val(field, item, field.format)
        },

        doAction(action, item, data = null) {
            this.$emit(action, item, data)
            return false;
        },

        visibilityClass(field, item) {
            let cls = '';
            if (field.type === 'badge' && !this.getVal(field, item)) cls += ' invisible'
            if (field.hidden) cls += ' invisible'
            if (field.primary) cls += 'primary'
            if (field.above) cls += ' above_'+field.above;
            if (field.below) cls += ' below_'+field.below;
            if (typeof field.if === "function") {
                if (!field.if(item[field], item)) cls += ' invisible'
            }
            return cls.trim()
        },

        getVal(field, data) {
            let tgt = field.target?field.target:field.prop
            if (!tgt) return;

            if (tgt.indexOf('.') > -1) {
                let t;
                t = tgt.split(/\./g)
                for (let f of t) {
                    if (typeof data[f] === "undefined") return undefined
                    else data = data[f]
                }
                return data
            }
            else return data[tgt]
        },

        itemTitle(field, item) {
            const type = typeof field.type === "function"?field.type():field.type
            if (type === 'boolean') return this.getVal(field, item) ? 'Yes':'No'
        },

        val(field, data, format = null) {
            if (this.noFormatting) return this.getVal(field, data);
            if (!field.prop) return null;
            let v, p = field.prop.split(/\./g), res = data;
            while (p && p.length > 0) {
                v = p.shift();
                if (!res[v]) {
                    break
                }
            }
            res = format && !this.preformatted ? format(res[v]?res[v]:null, res) : this.getVal(field, data)
            if (typeof res === 'string' && field.shorten && res.length > field.shorten) return res.substr(0, field.shorten)+'...'
            return res;
        },
    }
}
